import React, {  useEffect,   useState } from "react";
import { URButton } from "../../../../shared/widgets/button";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";
import styles from "./meetingDetailsLeft.module.scss";
import iconimage from "../../../../styles/images/grid_image.svg";
//import iconmusic from "../../../../styles/images/grid_music.svg";
//*import users from "../../../../styles/images/1a.png";
import { Modal, Tooltip, Popover, Select } from "antd";
//*import demo3 from "../../../../styles/images/doc.png";
//*import UserInputwithImage from "../../../../shared/widgets/inputwithimage";
//*import { URInput } from "../../../../shared/widgets/input";
import { useSelector } from "react-redux";
import { copyTemplate } from "../../../../base/meetingService/utils";
import {  storeCurrentMeetingDetail, storeMeetingPage, storeMOM, storePreviousMeetingDetail, storeWindowState } from "../../../../base/meetingService/meetingStoreServices";
import moment from 'moment';
//*import { findIndex, isArray } from "lodash";
import _, { isArray } from "lodash";
import {
  excelMimeFormats, pptMimeFormats, wordMimeFormats,
  zipMimeFormats, imageFormatType, bytesToSize
} from "../../../../base/utils";
import iconpdf from "../../../../styles/images/grid_pdf.svg";
import iconppt from "../../../../styles/images/grid_ppt.svg";
import iconword from "../../../../styles/images/grid_word.svg";
import iconxls from "../../../../styles/images/grid_xls.svg";
import iconzip from "../../../../styles/images/grid_zip.svg";
import iconxd from "../../../../styles/images/grid_xd.svg";
import { LoginState, UserDetails } from "../../../../models/model";
import store from "../../../../context/store/store";
import SingleParticipantList from "../singleParticipantList";
import { addParticipantsService, editMeetingApi, getMeetingLists } from "../../../../base/meetingService/apiService";
import { RRule } from 'rrule';
import ImageZoom from "../../../chat/chatsection/imagezoom";
import { findHostName, findHostNameYou, getFileExt, searchHandler, searchHighlight, shortFileName, toastInformation, userStatusColor } from "../../../../base/callService/common";
import { RRuleTimeCal } from "../../../../base/meetingService/utils/meetingServices";
import outlookadd from "../../../../styles/images/outlookadd.svg";
import gcal from "../../../../styles/images/gcal.svg";
import ical from "../../../../styles/images/ical.svg";
import { createGoogleLink, createOutlookLink, icsDownload } from "../../../../base/meetingService/utils/meetingServices";
import { useHistory } from "react-router-dom";
import taskimg2 from "../../../../styles/images/task2.svg";
import MeetingDetailsSummary from "../meetingDetailsSummary";
import ProfileAvatarGroup from "../../../chat/leftsidebar/profileavatargroup";	



type MeetingDetailState = {
  passwordView: boolean;
  uploadedFile: any;
  alternateHostVal: any;
  isPreviewFileModal: boolean;
  isPreviewImageModal: boolean;
  uploadedFileUrl: string;
  isAlternateHostModal: boolean;
  closeModal: boolean;
  meetingDetail: any;
  alternateHostModalOpenClose: string;
  removeAltHostModal: boolean;
  altHostButton: boolean;
  isCopyModal: boolean; 
  contactList: Array<any>; 
  favContactList: Array<any>; 
  searchKey: string; 
  addParticipants: any, 
  participantSipiIdList: any, 
  hoverVisible: boolean,
  isPerformanceModal:boolean
  
};
type MeetingDetailProps = {
  scrollValue:boolean;
}

export default function MeetingDetailsLeft({scrollValue}:MeetingDetailProps) {
  let { meetingReducer }: any = useSelector((state: any) => state);
  let { detailPage, currentWindowState, previousMeetingDetailPage, getListInput, performanceData,part_MOM,videoRecordingList,planBased } = meetingReducer;
  const { workContacts, favContacts, deleteContacts } = store.getState().contactReducer;
  const [getData, setData] = useState<MeetingDetailState>({
    passwordView: false, uploadedFile: {}, alternateHostVal: [], uploadedFileUrl: "",altHostButton:false,
    isPreviewFileModal: false, isAlternateHostModal: false, closeModal: false, meetingDetail: {}, alternateHostModalOpenClose: "",isPreviewImageModal: false,removeAltHostModal:false,
   isCopyModal: false, contactList: workContacts, searchKey: "", favContactList: [], addParticipants: detailPage.participants, isPerformanceModal:false,participantSipiIdList: [], hoverVisible: false
});
  const history = useHistory();
  //const { isLeftToast }: toastState= useSelector((state: toastState) => state);
  let previousMeetingArray: any = ['Completed', 'Missed','Cancelled'];
  let upcomingMeetingArray: any = ['Start', 'Join', 'Ongoing Meeting','Rejoin'];
  let { userdetails }: LoginState = store.getState().loginReducer;
  let firstIndex = detailPage.timezone?.indexOf("(");
  let lastIndex = detailPage.timezone?.lastIndexOf(")");
  let finalVal = detailPage.timezone?.substring(firstIndex, lastIndex + 1);
  let alternateHost = _.find(detailPage.participants, function(o) {
    return o.roletype === 2;
  });
  let hostName = _.find(detailPage.participants, function(o) {
    return o.roletype === 1;
  });
      let replaced_url:any= detailPage.invite_url?.includes("stagemeet") ? detailPage.invite_url : detailPage.invite_url?.replace('meet.unifiedring', 'meet.worktual');
  let splittedHostName = hostName ? hostName?.name?.split(" "): "";
  let splittedAltHostName = alternateHost?.name?.split(" ");


  let editRRule:any = {}
  if(detailPage.rrule && !detailPage?.rrule?.includes('FREQ=FORTNIGHTLY') && detailPage.rrule.includes('UNTIL') ){
   editRRule = new RRule(RRule.parseString(detailPage?.rrule));
  }
  else{
    editRRule={}
  }
  const [performanceMetricesBtn, setPerformanceMetricesBtn] = useState(false)
  const [AlternateHostBtn, setAlternateHostBtn] = useState(false)

  // const popOverVisibleChange = (val: any) => {

  // }

  const copyMeetingURL = () => {
    copyTemplate("copy");
    toastInformation("Meeting Link Copied");
  };

  let resContact: any = searchHandler(getData.contactList, getData.searchKey);
  let len = Math.round((resContact?.length / 8));
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
  let favList: Array<any> = _.filter(favContacts, ((contacts: any) => {
    return !Object.keys(contacts).some(key => key === 'team_id_prefix');
  }));

  const alternateHostDetail = (value: any,obj:any) => {
    try{
      if(!_.isEmpty(value))
      {let data = JSON.parse(obj[0].key);
       let HostDetail = {
         email: data.email_id,
         ext: data.ext,
         name: data.caller_id,
         profile_img:data.ImageURL,
         roletype: 2,
         sipid: data.sip_login_id,
         user_type: "company"
        };
        setData({...getData,alternateHostVal: HostDetail })
      }
      else {
         setData({ ...getData, alternateHostVal: {} })
      }
    }catch(e){

        console.log("alternateHostDetail >>>>", e)
    }

  };

  useEffect(() => {
   
    // {Performance Metrices}
    const PerformanceMetrices = planBased.find((item:any) => item.featureid === 533);
    if (PerformanceMetrices && PerformanceMetrices.value1 === "Yes") {
      setPerformanceMetricesBtn(false); 
    } else {
      setPerformanceMetricesBtn(true);
    }

     // {AlternateHost}
    const AlternateHost = planBased.find((item:any) => item.featureid === 20);
    if (AlternateHost && AlternateHost.value1 === "Yes") {
      setAlternateHostBtn(false); 
    } else {
      setAlternateHostBtn(true);
    }
  
  }, [planBased]); 

  const backTodetailPage = () => {
    if(history.location.pathname.includes("meetingDetails")){
      storeWindowState("mainPage");
      history.push("/meeting");
    }
    if(!_.isEmpty(previousMeetingDetailPage)){
      storeCurrentMeetingDetail(previousMeetingDetailPage);
      storeMeetingPage(previousMeetingDetailPage);
      storePreviousMeetingDetail({});
    }
    else{
      storeWindowState("mainPage");
      storeCurrentMeetingDetail({});
      storeMeetingPage({});
    } 
  };

  const backToTemplateList = () => {
    // storeWindowState("mainPage");
    storeWindowState("templateList");
  }

  const passwordViewHide = () => {
    let { passwordView } = getData;
    setData({...getData,passwordView:!passwordView});
  };

  const openurl = () => {
    let replaced_url: any = detailPage.invite_url?.includes("stagemeet") ? detailPage.invite_url : detailPage.invite_url?.replace('meet.unifiedring', 'meet.worktual');
    window.open(replaced_url, "_blank");
  }


  const downloadAttachment = () => {

  var xhr = new XMLHttpRequest();
  xhr.open("GET", getData.uploadedFile?.fileUrl, true);
  xhr.responseType = "blob";
  xhr.onload = function () {
    var urlCreator = window.URL || window.webkitURL;
    var imageUrl = urlCreator.createObjectURL(this.response);
    var tag = document.createElement("a");
    tag.href = imageUrl;
    tag.download = getData.uploadedFile.fileName;
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
  };
    xhr.send();
    
};

  const isPreviewModalHide = (file: any) => {
    if (imageFormatType.includes(file.mimeType)) {
        setData({...getData,uploadedFile:file,isPreviewImageModal:true});
    }
  else
   { const URL = `https://drive.google.com/viewerng/viewer?embedded=true&url=${file.fileUrl}#toolbar=0&scrollbar=0`;
    setData({...getData,uploadedFile:file,uploadedFileUrl:URL,isPreviewFileModal:true});}
  };

  const removeAlternateHost = () => {
   let updatedInfo: any = detailPage;
    let removedArrayIndex = _.findIndex(detailPage.participants, function (res: any) { return res.roletype === 2; });
     detailPage.participants.splice(removedArrayIndex,1);
    updatedInfo = {
      ...updatedInfo, participants: detailPage.participants
      };
      editMeetingApi(detailPage.uuid, updatedInfo).then((res: any) => {
        if (res?.statusCode=== 200) {
          setData({ ...getData,alternateHostVal:{},removeAltHostModal:false});
        }
      });
  }

  const removeAltModal = () => {
     setData({ ...getData,removeAltHostModal:true});
  }

  const openAlternateHostModal = () => {
    setData({...getData,isAlternateHostModal:true,alternateHostModalOpenClose:"openmodal",altHostButton:false});
  };

  const addAlternateHost = () => {
    setData({...getData,altHostButton:true})
    let updatedInfo: any = detailPage;
     if(!_.isEmpty(getData.alternateHostVal)) {
       (detailPage.participants).push(getData.alternateHostVal);
       editMeetingApi(detailPage.uuid, updatedInfo).then((res: any) => {
         if (res?.statusCode===200) {
         updatedInfo = {
        ...updatedInfo, participants: detailPage.participants
           };
      setData({...getData,alternateHostModalOpenClose:"closemodal",altHostButton:true,alternateHostVal:[]})
      setTimeout(() => {
      setData({...getData,isAlternateHostModal:false,alternateHostVal:[],altHostButton:true});
      toastInformation(`${getData.alternateHostVal.name} assigned as alternate host`,"success")
     }, 500);
           
      }
    });
    }
      }
  const { Option } = Select;
  const searchContact = (e: string) => {
    let searchName = e.toLowerCase();
    if (searchName !== "") {
      let filtered = _.filter(workContacts, function (name: any) {
        return name.caller_id?.toLowerCase().includes(searchName) ||
          name.ext?.toString().includes(searchName) || name.team_name?.includes(searchName) ||
          name.email_id?.toLowerCase().includes(searchName);
      });
      let filtered_favs = _.filter(favList, function (name: any) {
        return name.caller_id?.toLowerCase().includes(searchName) ||
          name.ext?.toString().includes(searchName) || name.team_name?.includes(searchName) ||
          name.email_id?.toLowerCase().includes(searchName);
      });
      setData({ ...getData, contactList: filtered, searchKey: searchName, favContactList: filtered_favs });
    }
    else { setData({ ...getData, contactList: workContacts, searchKey: searchName, favContactList: favList }); }
  };

  const contactFocus = () => {
    setData({ ...getData, searchKey: "", contactList: workContacts });
  };

  const popupOnchange = (val: any, obje: any) => {
    try {
      let participantDetails: any = [];
      let participantSipidList: any = [];

      obje.map((store: any) => {
        let data = JSON.parse(store.key);
        let HostDetail = {
          email: data.email_id,
          ext: data.ext,
          name: data.caller_id,
          profile_img: data?.ImageURL,
          roletype: 3,
          sipid: `${data.sip_login_id}`,
          user_type: "company"
        };
        participantDetails.push(HostDetail);
        participantSipidList.push(parseInt(data?.sip_login_id))
      });

      setData({ ...getData, addParticipants: participantDetails, participantSipiIdList: participantSipidList, contactList: workContacts, searchKey: "" });
    } catch (error) {
      console.log("popupOnchange >>>>>", error)
    }
  }

  const closeModal = () => {

    setData({
      ...getData,  alternateHostModalOpenClose: "closemodal"
    });
    setTimeout(() => {
      setData({...getData,isAlternateHostModal:false});
     }, 500);
  };

  const addParticipanttoMeeting = () => {
    setData({ ...getData, hoverVisible: false });
    let objectList: any = [];
    let alterHostPresent = false;
    if (detailPage.participants && isArray(detailPage.participants) && detailPage.participants.length > 0) {
      objectList = detailPage.participants.reduce((acc: any, curr: any) => {
        if (curr?.name) {
          return (acc[curr["sipid"]] = curr, acc);
        }
      }, {});
    }
   
    getData.addParticipants.map((part: any, index: any) => {
       let exis = objectList[part.sipid];
       alterHostPresent = (alternateHost && alternateHost.sipid === part.sipid);
    
     if(!exis) { detailPage.participants.push(part); }
      
      // if (exis) {
      //   // console.log("1st iff--------------",exis);
      //   getData.addParticipants[index].roletype = exis.roletype;
      //   let arr: any = Object.keys(objectList);
      //   arr.filter((elem: any) => {
      //  console.log(elem,"elem-----");
       
      //     if (elem !== part?.sipid){
      //       // uniqueList=_.uniqBy(objectList,'sipid');
      //       getData.addParticipants.push(objectList[elem]);
      //     // console.log(getData.addParticipants,"1st if getData.addParticipants====");
          
      //     }
      //   })
      // }
      // if(!exis) {
      //   // console.log("2st iff--------------",exis);
      //   let arr: any = Object.keys(objectList);
      //   arr.filter((elem: any) => {
      //     console.log(elem,"elem11111-----");
      //     if (elem !== part?.sipid){
      //     getData.addParticipants.push(objectList[elem]);
      //     }
      //     // console.log(getData.addParticipants,"2nd if getData.addParticipants====");
      //   })
      // }
    });
 
    if(alterHostPresent) {
      let alterIndex = (alternateHost && detailPage.participants.findIndex((elem:any)=>alternateHost.sipid === elem.sipid));
      
            if( alterIndex !== -1)  {
             detailPage.participants[alterIndex].roletype = 3;
            }
    }

    // let findIndex = _.findIndex(getData.addParticipants, function (res: any) {
    //   return `${userdetails.sip_login_id}` === res?.sipid;
    // });

    // if (findIndex === -1) {
    //   // console.log("3rd iff--------------",findIndex);
    //   let loggedDetails: any = objectList[userdetails?.sip_login_id];
    
    //   getData.addParticipants.push(loggedDetails);
     
    // }

   

    // detailPage.participants = getData.addParticipants
    storeMeetingPage(detailPage)
     const hostParticpants = [...getData.addParticipants,hostName];

    let inputData = {
      uuid: detailPage?.uuid,
      participants: hostParticpants
      // participants: updateHostparticipants

    }
    addParticipantsService(inputData).then((res: any) => {
      if (res?.statusCode === 200) {
        let data: any = {};
        data.offset = 0;
        data.limit = 10;
        data.filter = getListInput.filter;
        data.searchText = '';
        data.sort = '1';
        getMeetingLists(data);
        toastInformation("Participants Updated Successfully", "success");
 
      }

    });

  }

  const closeFileModal = () => {
    setData({
      ...getData, isPreviewFileModal: false,
     isPreviewImageModal: false,removeAltHostModal:false
    });
  };
  const addCalendar = (calendarType: any) => {
    history.push("/meeting");
    const participantsEmail = detailPage.participants.map((value: any) => value.email).toString();
    let host: any = store.getState().loginReducer.userdetails || [];
    let replaced_url:any=detailPage.invite_url?.includes("stagemeet") ? detailPage.invite_url : detailPage.invite_url?.replace("meet.unifiedring","meet.worktual")
    let calenderInfo = {
      'title': detailPage.title,
      'meetingId':detailPage.meeting_id,
      'description': detailPage.description,
      'participantsEmail': participantsEmail,
      'startTime': moment.utc(new Date(detailPage.start_timestamp)).format("YYYYMMDDTHHmmss[Z]"),
      'endTime': moment.utc(new Date(detailPage.end_timestamp)).format("YYYYMMDDTHHmmss[Z]"),
      'organizer': { 'name': host?.caller_id, 'email': host?.email },
      'password':( detailPage.password !== "" && detailPage.is_custom_password) ? "Password : " + detailPage.password : "",
      'altDescription' : host.caller_id + " has Invited you to a meeting! \n\n"+
        "Title : " + detailPage.title + ' \n\n' +
        "About Meeting : " + detailPage.description+ ' \n\n'+
        "Join : " + replaced_url + ' \n\n' +
        "Meeting-ID : " + detailPage.meeting_id + ' \n\n'+
      'Password : ' + ( detailPage.password !== "" && detailPage.is_custom_password) ? detailPage.password : "",
    // 'rrule': rRule,
      'participants':detailPage.participants
    };

    if(calendarType=== "Google")
    { createGoogleLink(calenderInfo);}
    else if (calendarType === "Outlook")
    {createOutlookLink(calenderInfo);}
    else if (calendarType === "ICal") {
      icsDownload(calenderInfo,"add");
    }
  };

  const setPopOverVisible = () => {
    let arrayList: any = [];
    detailPage.participants.map((contacts: any, index: any) => {
      // arrayList.push(contacts.sipid);

      if (contacts.sipid !== userdetails.sip_login_id) arrayList.push(parseInt(contacts.sipid));
    })
    setData({ ...getData, participantSipiIdList: arrayList, hoverVisible: true });
  }

  const closeModal1 = () => {
    setData({ ...getData, participantSipiIdList: [], hoverVisible: false });
    
    
  }
  const openMetricsModal = () => {
    setData({ ...getData, isPerformanceModal: true });
  }
  const closePerformanceModal = () => {
    setData({ ...getData, isPerformanceModal: false });
  }
  const setRecordPage=()=>{
    storeWindowState('recordedVideo')
  }

  const content = (
    <div className={styles.popoverInviteRemove}>
      <Select
        mode='multiple'
        style={{ width: '100%' }}
        placeholder="Search for extension to member"
        className="newselects taskcreations addRemoveUser inviteInnerinput"
        dropdownClassName="newChatSel meetingdropdown"
        showSearch={true}
        filterOption={false}
        value={getData.participantSipiIdList}
        onSearch={searchContact}
        onChange={popupOnchange}
      >

        {(getData.favContactList?.length > 0 && getData.searchKey === '') &&
          <div className="titlesdrop">Favourite / Frequently Contacted</div>}
        {getData.favContactList?.map((favcontactName: any, index: any) => {

          return <div key={index} value={favcontactName?.sip_login_id}>

            <div className="dropdowndesign">
              <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                profileInfo={
                  (favcontactName?.ImageURL !== null && favcontactName?.ImageURL !== "") ?
                    (<>
                      <img src={favcontactName?.ImageURL} alt="" />
                      <URStatusDot className={userStatusColor(favcontactName.user_status, 'small')} /></>) :
                    (<>
                      <span>{favcontactName?.caller_id?.charAt(0).toUpperCase()} </span>
                      <URStatusDot className={userStatusColor(favcontactName.user_status, 'small')} />
                    </>)
                } />
              <div className="names">{favcontactName.caller_id}</div>
              <div className="ext">{favcontactName?.ext}</div>
            </div>
          </div>;
        })}
        {getData.contactList?.map((contactName: any, index: any) => {
          let highlighted: any = searchHighlight(contactName, getData.searchKey);
          return <Option key={JSON.stringify(contactName)} value={contactName.sip_login_id}>
            <div className="dropdowndesign">
              <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                profileInfo={
                  (contactName?.ImageURL !== null && contactName?.ImageURL !== "") ?
                    (<>
                      <img src={contactName?.ImageURL} alt="" />
                      <URStatusDot className={userStatusColor(contactName.user_status, 'small')} /></>) :
                    (<>
                      <span>{contactName?.caller_id?.charAt(0).toUpperCase()} </span>
                      <URStatusDot className={userStatusColor(contactName.user_status, 'small')} />
                    </>)
                } />
              {getData.searchKey !== '' ?
                <div className="names">{(highlighted?.middleMsg !== "") ? (<>{highlighted?.firstMsg}
                  <b className={styles.highlight}>{highlighted?.middleMsg}</b>
                  {highlighted?.lastMsg}</>) :
                  (<>{contactName?.caller_id}</>)}</div> :
                <div className="names">{contactName.caller_id}</div>}
              <div className="ext">{contactName.ext}</div>
            </div>
          </Option>;
        })}</Select>
      <div className={styles.inviteRemoveFooter}>
        <URButton className='urButton buttonWhite buttonSm mr8' name="Cancel" onClick={closeModal}></URButton>
        <URButton className='urButton buttonBlue buttonSm right8' name="Update" onClick={addParticipanttoMeeting}></URButton>
      </div>
    </div>
  );


 

  let splitedLetter = detailPage && detailPage?.hostName.split(" ");
  let profileName = splitedLetter[0]?.trim()?.charAt(0)+splitedLetter[1]?.trim()?.charAt(0);
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
  let performanceDataArr = [];
    if (loggedUserDetails?.sip_login_id === detailPage?.sip_id) 
      {
        performanceDataArr = performanceData?.slice();
      } 
      else 
      {
        let value = detailPage?.participants?.find((elem:any) => {
  
          return elem?.sipid === loggedUserDetails?.sip_login_id
  
          });
        if(value)
        { 
          let data = performanceData?.find((elem:any) => {
            return elem?.ext?.toString() === loggedUserDetails?.ext?.toString()
          });
          if (data) performanceDataArr?.push(data);
        }
        else
        {
          console.log("can't find the data")
        }
  
      }
  return (
    <>
      <div className={styles.meetingDetailsLeft}>
        {/* <div className={styles.backTotemplate}>
          <span className="icon_searchlft" onClick={currentWindowState === "meetingDetails" ? backTodetailPage : backToTemplateList}></span>
          <label>{currentWindowState === "templateDetails" ? "Saved Template" : ""}</label>
        </div> */}
        <div className={styles.meetingsTitle}>{detailPage?.title}</div>
        <div className={styles.meetingsDesc}>{detailPage?.description}</div>
        <div className={detailPage.status === "Missed" ? `${styles.detailsBox} ${styles.missedBox}` :
          detailPage.status === "Completed" ? `${styles.detailsBox} ${styles.completedBox}` :
            detailPage.status === "Cancelled" ? `${styles.detailsBox} ${styles.cancelBox}`: `${styles.detailsBox}`}>
          <div className={styles.detailsBoxTop}>
          <URAvatarGroup className='lefts size28 colorBG4' profileInfo={<><span>{profileName.toUpperCase()}</span>
              <URStatusDot className='stsDotsmxs green' /></>} />
            <div className={styles.userName}>
              {/* <Tooltip placement="top" title={!_.isUndefined(splittedHostName) ? splittedHostName[0] : ""}><label>{splittedHostName[0]}</label></Tooltip> */}
              <span className={styles.titleHost}> {!_.isUndefined(findHostNameYou(detailPage)) && `${findHostNameYou(detailPage)}(Host)`}</span></div>
            {alternateHost && 
              <>
                <URAvatarGroup className='lefts size16' profileInfo={<><span>{alternateHost?.name?.charAt(0)}</span>
                  <URStatusDot className='stsDotsmxs green' /></>} />
                <div className={styles.userName}><Tooltip placement="top" title={splittedAltHostName[0]}><label>{splittedAltHostName[0]}</label></Tooltip>
                  <span className={styles.titleHost}> (Alternate Host)</span></div>
              </>}
            
            {(!previousMeetingArray.includes(detailPage.status) && detailPage.status !=="Ongoing Meeting" && detailPage.sip_id === userdetails.sip_login_id) && currentWindowState==="meetingDetails" &&
              <div className={`${styles.altTitle} ${AlternateHostBtn ?'disabledIcon':''}`} onClick={alternateHost ? removeAltModal : openAlternateHostModal}>
                {alternateHost ?  "Remove ": "+ Add Alternate Host"}</div>}
          
            {/* <div className={styles.meetId}>615-375-0127</div> */}
            {currentWindowState === "templateDetails" && <div className={styles.editedDetail}>
              <span className={styles.lastTime}>Last Modified Time</span>
              <span className={styles.calDot}></span>{moment(detailPage.start_timestamp).format("MMM DD YYYY")}
              <span className={styles.calDot}></span>{moment(detailPage.start_timestamp).format('LT')}
            </div>}
            { currentWindowState === "meetingDetails" && <Tooltip placement="top" title="Meeting ID"><span className={styles.calDotId}>{detailPage?.meeting_id}</span></Tooltip>}
          </div>
          <div className={styles.detailsBoxBody}>
            <div className={styles.detList}>
              <div className={styles.titleOne}>Duration</div>
              <div className={styles.titleTwo}>{detailPage.duration_minutes} minutes</div>
            </div>
            <div className={styles.detList}>
              <div className={styles.titleOne}>Date</div>
              <div className={styles.titleTwo}>{moment(detailPage.start_timestamp).format("Do MMM")}</div>
            </div>
            <div className={styles.detList}>
              <div className={styles.titleOne}>Time</div>
              <div className={styles.titleTwo}>{(moment(detailPage.start_timestamp).format('hh:mm A')).split(" ")}
                - {detailPage.rrule !== "" ? (moment(RRuleTimeCal(detailPage.start_timestamp,detailPage.duration_minutes)).format('hh:mm A'))
                        : (moment(detailPage.end_timestamp).format('hh:mm A'))}</div>
              <div className={styles.titleOne}>{finalVal}</div>
            </div>
           {detailPage?.rrule!== "" && <div className={styles.detList}>
              <div className={styles.titleOne}>Recurring</div>
              <div className={styles.titleTwo}>{detailPage?.rrule?.includes("FREQ=DAILY")
                ? "Daily" : detailPage?.rrule?.includes("FREQ=WEEKLY")
                  ? "Weekly" : detailPage?.rrule?.includes("FREQ=MONTHLY")
                    ? "Monthly": "None"}</div>
            </div>}
            {detailPage?.rrule!== "" &&<div className={styles.detList}>
              <div className={styles.titleOne}>Occurrences</div>
              <div className={styles.titleTwo}>{ detailPage.rrule  ? editRRule?.options?.interval : "None"}</div>
            </div>}
          </div>
          {!_.isEmpty(detailPage.files) &&
            <>
              <div className={styles.attTitle}>Attached Documents</div>
            {detailPage.files.map((elem: any,index:any) => {
                return (
                  <div className={styles.detailsBoxFooter} key={index} >
                    <div className={styles.filesChat}>
                      <div className={styles.filesImage}>
                        <img src={wordMimeFormats.indexOf(elem?.mimeType) > -1
                  ? iconword :
                  pptMimeFormats.indexOf(elem.mimeType)>-1
                    ? iconppt: elem?.mimeType==="application/pdf"?
                      iconpdf:excelMimeFormats.indexOf(elem.mimeType)>-1
                        ? iconxls : zipMimeFormats.indexOf(elem.mimeType) > -1
                          ? iconzip : imageFormatType.indexOf(elem.mimeType) > -1 ? iconimage: iconxd
                } alt="filename" /></div>
                      <div className={styles.filesDetails} onClick={()=>isPreviewModalHide(elem)}>
                        <span className={styles.fileName}>{`${shortFileName(elem.fileName)}..${getFileExt(elem.fileName)}`}</span>
                        <span className={styles.fileDt}>{bytesToSize(elem.fileSize) }</span>
                      </div>
                    </div>
                  </div>);
              }) }
            </>
          }
        
          {/* <div className={styles.attTitle}>Meeting Records</div>
          <div className={styles.detailsBoxFooter}>
            <div className={styles.filesChat}>
              <div className={styles.recTranscript}>
                <span className="icon_meetfill"></span>
              </div>
              <div className={styles.filesDetails} >
                <span className={styles.fileName}>View Transcription</span>
              </div>
            </div>
            <div className={styles.filesChat}>
              <div className={styles.recVideo}>
                <span className="icon_meetfill"></span>
              </div>
              <div className={styles.filesDetails}>
                <span className={styles.fileName}>View Recorded Video</span>
              </div>
            </div>
          </div> */}
        </div>
        <div className={styles.participantArea}>
            <div className= {`${styles.participantTopRow} ${styles.participantalign}`}>
              <span className={styles.participantTitle}>Participants ({detailPage?.participants?.length})</span>
              {detailPage.status==="Start"&&
              
                <span className={styles.inviteOrRemove} onClick={setPopOverVisible}> Invite / Remove</span>
              }
          
              {currentWindowState !== "templateDetails" && ((userdetails.sip_login_id === detailPage.sip_id && upcomingMeetingArray.includes(detailPage.status)) ||
                (userdetails.sip_login_id !== detailPage.sip_id && upcomingMeetingArray.includes(detailPage.status) && detailPage.is_participant_invite_guest)) &&
                <Popover content={content} title="" trigger="click"
                  overlayClassName='customAddImage inviteRemove' placement="bottomRight" visible={false}>
                  {/* <div className={styles.inviteRemove}><div className={styles.altTitle} onClick={setPopOverVisible}>Invite / Remove</div></div> */}
                  {/* <div className={styles.inviteRemove}><div className={styles.altTitle} onClick={setPopOverVisible}>Invite </div>
                <span className={styles.altTitledivider}>/</span>
                <div className={styles.altTitle} onClick={setPopOverVisible}> Remove</div></div> */}
                </Popover>} 
            </div>

            <div className={styles.participantBoxArea}>
              {/* <div className={`scroller ${styles.group} ${styles.userGroup}`}>
                <p className={styles.userTitle}>Group (2)</p>
                <div className={styles.avatarList}>
                </div>
              </div> */}
              <div className={`scroller ${styles.member} ${styles.userGroup}`}>
                <p className={styles.userTitle}>{`Members (${detailPage.participants.length})`}</p>
                <div className={styles.avatarList}>
                  {
                    detailPage.participants ?.map((contactName: any,index:any)=>{
                     
                      return (<>  <div className={styles.avtarSec}>
                        <div className="usergroupss">
                          <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                            profileInfo={
                              (contactName.profile_img !== null && contactName.profile_img !== "") ?
                                (<>
                                  <img src={contactName.profile_img} alt="" className={styles.imgSelected} />
                                  <URStatusDot className={userStatusColor(contactName.user_status, 'small')} /></>) :
                                (<>
                                  <span>{contactName?.name?.charAt(0).toUpperCase()} </span>
                                  <URStatusDot className={userStatusColor(contactName.user_status, 'small')} />
                                </>)
                            } />
                        </div>
                        <div className={styles.teamName}>{contactName.name}</div>
                        <span className={styles.ext}>{contactName.ext}</span>
                      </div></>)
                    })
                  }
                </div>
              </div>
            </div>
          </div>
          <br></br>
          <div>
           
            <div className={styles.ppmatricsparentcon}>
            {videoRecordingList?.length > 0 && <div className={styles.innercontainerpp}  onClick={setRecordPage}>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 14.01C7.79 14.01 6 12.22 6 10.01C6 7.8 7.79 6.01 10 6.01C12.21 6.01 14 7.8 14 10.01C14 12.22 12.21 14.01 10 14.01Z"
                  fill="#DE003D"
                />
              </svg>
            </div>
            <div>
              <p>View Recorded Video</p>
            </div>
          </div> }
          {/* <div className={styles.innercontainerpp}>
            <div className={styles.ppmetricsscgcon}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="16"
                viewBox="0 0 20 16"
                fill="none"
              >
                <path
                  d="M13.1818 1.7743C12.0935 0.687797 10.5083 0.531297 9.01671 0.494397C8.33191 0.475997 7.74771 0.466797 7.16341 0.466797C6.57911 0.466797 5.99491 0.475997 5.31011 0.494397C3.82791 0.531297 2.23321 0.687797 1.14511 1.7743C0.0194101 2.9071 0.0288104 4.7488 0.000610352 6.2039V9.8046C0.0288104 11.2597 0.0194101 13.1014 1.14511 14.2249C2.23321 15.3114 3.81861 15.4681 5.31011 15.5048C5.99491 15.5232 6.57911 15.5325 7.16341 15.5325C7.74771 15.5325 8.33191 15.5232 9.01671 15.5048C10.4988 15.4681 12.0935 15.3114 13.1818 14.2249C14.3073 13.1014 14.2981 11.2597 14.3261 9.8046C14.3356 9.206 14.3449 8.5982 14.3356 7.9997C14.3356 7.4012 14.3356 6.8026 14.3261 6.1948C14.298 4.7397 14.3073 2.8979 13.1818 1.7743Z"
                  fill="#757676"
                />
                <path
                  d="M18.8408 3.14C18.6482 3.14 18.4507 3.1944 18.2643 3.3138L14.8826 5.4803V10.519L18.2643 12.6853C18.4507 12.8047 18.6484 12.8593 18.841 12.8593C19.4451 12.8593 19.9993 12.3232 19.9993 11.5739V4.4255C19.9993 3.6764 19.4449 3.14 18.8408 3.14Z"
                  fill="#757676"
                />
              </svg>
            </div>
            <div>
              <p>Recorded Files (7)</p>
            </div>
          </div> */}
           { ((performanceDataArr && performanceDataArr.length > 0) && part_MOM.length > 0) &&(
              <div className={`${styles.innercontainerpp} ${performanceMetricesBtn ? 'disabledIcon':''}`}>
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M19.0221 2.21867C18.9911 1.56227 18.4625 1.03047 17.8065 0.995469C17.6263 0.985869 17.4388 0.980469 17.2452 0.980469C14.7681 0.980469 11.2513 1.84717 8.49638 5.64247C8.40288 5.77187 8.31038 5.90527 8.21558 6.04887L5.40798 6.28907C4.54078 6.36327 3.69778 6.88847 3.18658 7.67437L1.12168 10.8484C0.949279 11.1143 0.916879 11.4276 1.04018 11.671C1.15468 11.895 1.38298 12.0267 1.64688 12.0267C1.66978 12.0267 1.69278 12.0257 1.71618 12.0237L5.32558 11.7149C5.12098 12.1826 4.94858 12.5897 4.81878 12.9028C4.65398 13.3035 4.71818 13.7143 4.98208 13.9796L5.93988 14.9433L5.93698 14.9435C6.10568 15.1112 6.33448 15.1997 6.58128 15.1997C6.71698 15.1997 6.85788 15.173 6.99758 15.118C7.32378 14.9885 7.75688 14.816 8.25268 14.607L7.92088 18.2662C7.89398 18.5634 8.02588 18.8189 8.26858 18.9448C8.36768 18.9957 8.47878 19.0206 8.59378 19.0206C8.76008 19.0206 8.93458 18.9684 9.09208 18.8673L12.274 16.8169C13.0601 16.3123 13.5909 15.4681 13.6695 14.6006L13.9241 11.7918C14.0679 11.6976 14.2049 11.6055 14.3316 11.5128C18.4319 8.55987 19.1405 4.70697 19.0221 2.21867ZM13.4459 10.3025C13.339 10.3806 13.2235 10.4579 13.1024 10.5372C12.7191 10.7881 12.4715 11.2005 12.43 11.6567L12.1754 14.4655C12.1385 14.8734 11.859 15.301 11.4613 15.5563L9.56158 16.7804L9.74638 14.7426C9.79398 14.2181 9.56278 13.707 9.13778 13.3962C8.87658 13.2053 8.56578 13.1071 8.25228 13.1071C8.05548 13.1071 7.85728 13.1459 7.66998 13.2248C7.31818 13.3731 6.99858 13.5025 6.72958 13.6101L6.32068 13.1987C6.42838 12.9432 6.55608 12.645 6.69988 12.316C6.91178 11.8314 6.85298 11.271 6.54488 10.841C6.26168 10.446 5.80658 10.2148 5.32588 10.2148C5.28338 10.2148 5.24068 10.2166 5.19768 10.2202L3.20918 10.3904L4.44408 8.49217C4.70168 8.09637 5.13008 7.81817 5.53608 7.78347L8.34368 7.54337C8.80098 7.50427 9.21528 7.25777 9.46798 6.87447C9.55048 6.74947 9.63108 6.63347 9.71038 6.52347C12.1359 3.18177 15.1467 2.48027 17.2453 2.48027C17.3422 2.48027 17.4377 2.48187 17.5309 2.48477C17.5788 4.36097 17.0692 7.69297 13.4459 10.3025Z"
                    fill="#00B885"
                  />
                  <path
                    d="M10.5921 7.19687C9.93488 7.85407 9.93488 8.91947 10.5921 9.57667C11.2493 10.2339 12.3148 10.2339 12.9717 9.57667C13.6289 8.91947 13.6289 7.85407 12.9717 7.19687C12.3147 6.53977 11.2493 6.53977 10.5921 7.19687Z"
                    fill="#00B885"
                  />
                  <path
                    d="M5.29208 14.6864C5.10088 14.4952 4.88238 14.3791 4.63678 14.338C4.56798 14.3265 4.49808 14.3207 4.42728 14.3207C4.24708 14.3207 4.06208 14.3584 3.87238 14.4339C3.60848 14.539 3.35358 14.7143 3.10798 14.9599C2.98688 15.0809 2.87798 15.2103 2.78088 15.3478C2.68378 15.4853 2.59778 15.6209 2.52308 15.7544C2.44838 15.8878 2.38468 16.0078 2.33138 16.1143C2.23448 16.3103 2.14388 16.5191 2.05918 16.7406C1.97468 16.9621 1.90098 17.1732 1.81798 17.416C1.74008 17.6446 1.66658 17.867 1.59218 18.0831C1.57218 18.1454 1.56438 18.2005 1.56878 18.2484C1.57318 18.2964 1.58928 18.3342 1.61688 18.3618C1.64518 18.3902 1.68328 18.4064 1.73068 18.4104C1.73748 18.4109 1.74438 18.4113 1.75118 18.4113C1.79268 18.4113 1.83758 18.4014 1.89548 18.3863C2.11248 18.3128 2.33498 18.2377 2.56318 18.1611C2.79138 18.0845 3.01658 18.0041 3.23848 17.92C3.46068 17.8359 3.66918 17.7449 3.86418 17.6472C3.97058 17.594 4.09048 17.5301 4.22408 17.4554C4.35768 17.3807 4.49308 17.2948 4.63058 17.1976C4.76828 17.1005 4.89768 16.9914 5.01848 16.8704C5.26428 16.6248 5.43958 16.37 5.54458 16.106C5.64958 15.842 5.68158 15.5872 5.64028 15.3416C5.59928 15.096 5.48298 14.8776 5.29208 14.6864Z"
                    fill="#00B885"
                  />
                </svg>
              </div>
              <div>
                
                <p onClick={openMetricsModal}>Perfomance Metrics</p>
              </div>
              </div>
           )
          }
        </div>

          </div>
        <>
          {currentWindowState==="meetingDetails" && !previousMeetingArray.includes(detailPage.status) &&
            <div className={styles.linkconlftrightsec}>     
              <div className={styles.copyLink} id="copy" onClick={openurl}>{replaced_url} </div>  
              <div className={styles.rightLinkbtn}onClick={copyMeetingURL}><span className="icon_copydoc" ></span><label>Copy Link</label></div> 
              </div>}
    
          {(userdetails.sip_login_id !== detailPage.sip_id && currentWindowState=== "meetingDetails" &&
            !previousMeetingArray.includes(detailPage.status) && detailPage.is_custom_password) &&
            <div className={styles.validationList}>
              <ul className={styles.listDetails}>
               <li className={styles.completed}>
                  <div className={!getData.passwordView ?
                  `${styles.passwordArea} ${styles.marTopPart}` : `${styles.passwordShowArea} ${styles.marTopPart}` }>
                    <span className={detailPage.password ? "icon_tick" : "icon_close"}></span>Password
                    <span className={styles.passText}>{detailPage.password}</span><span
                      className={getData.passwordView ? "icon_Viewpassword" : "icon_Password"}
                      onClick={passwordViewHide}></span>
                  </div></li>
              </ul>
            </div>
        }

        {upcomingMeetingArray.includes(detailPage.status) &&   < div className={styles.tourleftconsec}><div className={styles.participantTop}>
            <div className={styles.userName}>
              {/* <span className="icon_eventfill"></span> */}
              Add to :</div>
              <span className={styles.whiteBtnbdr} onClick={()=>addCalendar("Google")}><img src={gcal} alt=""
          /> Google Calendar</span>
          <span className={styles.whiteBtnbdr} onClick={()=>addCalendar("Outlook")}><img src={outlookadd}
            alt="" /> Outlook Calendar</span>
          <span className={styles.whiteBtnbdr} onClick={() => addCalendar("ICal")}><img src={ical} alt=""
          /> Download.ics</span>
          </div>
          
          </div>}
          
          
         {detailPage.status ==='Completed' &&  <MeetingDetailsSummary  scrollValue={scrollValue}/>}
          {userdetails.sip_login_id === detailPage.sip_id && (upcomingMeetingArray.includes(detailPage.status)) && 
            <div className={styles.validationList}>
              <div className={styles.validationlistTitle}>
                Host video <span className={styles.switchDt}>{detailPage.is_host_myvideo ? "ON" : "OFF"}</span>
                Participant video <span className={styles.switchDt}>
                  {detailPage.is_participant_video ? "ON" : "OFF"}</span>
              </div>
              <ul className={styles.listDetails}>
                {detailPage.is_custom_password && <li className={styles.completed}>
                  <div className={!getData.passwordView ?
                  `${styles.passwordArea}` : `${styles.passwordShowArea}` }>
                    <span className={detailPage.password ? "icon_tick" : "icon_close"}></span>Password
                    <span className={styles.passText}>{detailPage.password}</span><span
                      className={getData.passwordView ? "icon_Viewpassword" : "icon_Password"}
                      onClick={passwordViewHide}></span>
                  </div></li>}
                <li className={detailPage.is_record_meeting ? styles.completed : ""}><span className={detailPage.is_record_meeting ? "icon_tick" :
                  "icon_close"}></span>Record my meetings in (UR Cloud)</li>
                <li className={detailPage.is_participant_join_bef_host ? styles.completed : ""}>
                  <span className={detailPage.is_participant_join_bef_host ? "icon_tick" : "icon_close"}></span>
                  Allow participants joining before host enters</li>
                <li className={detailPage.is_participant_invite_guest ? styles.completed : ""}>
                  <span className={detailPage.is_participant_invite_guest ? "icon_tick" : "icon_close"}></span>
                  Allow Participants to invite guests</li>
                <li className={detailPage.is_participant_mute_entry ? styles.completed : ""}><span className={detailPage.is_participant_mute_entry ? "icon_tick" : "icon_close"}></span>
                  Mute Participants audio upon entry</li>
                <li className={detailPage.is_participant_waiting_room ? styles.completed : ""}><span className={detailPage.is_participant_waiting_room ? "icon_tick" : "icon_close"}></span>
                  Waiting Room</li>
              </ul>
          </div>}
        </>
      </div>

      {/* <Modal visible={isModalVisible2} className="meetingTranscription"  >
        <div className="modalheaders">
          <h2>Meeting Transcription</h2>
          <ul>
            <li><Tooltip placement="top" title={'Download'}> <span className="icon_Downloadstroke"></span>
            </Tooltip></li>
            <li><Tooltip placement="top" title={'Close'}><span className="icon_close" onClick={handleCancel2}></span>
            </Tooltip></li>
          </ul>
        </div>
        <div className="modalinnerbodyconsec">
          <div className="teamstanuptxt">
            <h3>Design team stand-up</h3>
            <p>9 Aug 2021 • 9:21 PM</p>
          </div>
          <div className="teammemberlist">
            <div className="leftsideicon">
              <URAvatarGroup className='lefts size28' profileInfo={<><img src={users} alt="" />
                <URStatusDot className='stsDotsm green' /></>} />
            </div>
            <div className="userdetails">
              <h3>Rachel Pearson</h3>
              <p>incidunt tristique neque, eget venenat is enim gravida quis.
                Fusce at eges as libero. C r a s convallis egestas ullam e</p>
            </div>
          </div>
          <div className="teammemberlist">
            <div className="leftsideicon">
              <URAvatarGroup className='lefts size28' profileInfo={<><span>D</span>
                <URStatusDot className='stsDotsm green' /></>} />
            </div>
            <div className="userdetails">
              <h3>Walter Hayes</h3>
              <p>incidunt tristique neque, eget venenat is enim gravida quis.
                Fusce at eges as libero. C r a s convallis egestas ullam e</p>
            </div>
          </div>
          <div className="teammemberlist">
            <div className="leftsideicon">
              <URAvatarGroup className='lefts size28 two' profileInfo={<><span>A</span><span>B</span></>} />
            </div>
            <div className="userdetails">
              <h3>Alex Roberts</h3>
              <p>incidunt tristique neque, eget venenat is enim gravida quis.
                Fusce at eges as libero. C r a s convallis egestas ullam e</p>
            </div>
          </div>
          <div className="teammemberlist">
            <div className="leftsideicon">
              <URAvatarGroup className='lefts size28 three'
                profileInfo={<><span>A</span><span>B</span><span>C</span></>} />
            </div>
            <div className="userdetails">
              <h3>Amber Vargas</h3>
              <p>incidunt tristique neque, eget venenat is enim
                gravida quis. Fusce at eges as libero. C r a s convallis egestas ullam e</p>
            </div>
          </div>
          <div className="teammemberlist">
            <div className="leftsideicon">
              <URAvatarGroup className='lefts size28 four'
                profileInfo={<><span>A</span><span>B</span><span>C</span><span>4</span></>} />
            </div>
            <div className="userdetails">
              <h3>Ashok</h3>
              <p>incidunt tristique neque, eget venenat is enim gravida quis.
                Fusce at eges as libero. C r a s convallis egestas ullam e</p>
            </div>
          </div>
        </div>
      </Modal> */}
      {/* <Modal title="Object module.pdf"
        centered
        visible={isModalVisible}
        onCancel={handleCancel}
        onOk={handleOk}
       
        cancelText="Cancel"
        okText="Delete Chat"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }}
        className="DocumentcustomPopup">
        <div className="chatNoteImgContent">
          <img src={demo3} alt="" />
        </div>

      </Modal> */}

      <Modal
        centered
        visible={getData.isPreviewFileModal}
        onCancel={closeFileModal}
        className="imagepreviewmodal"> 
        <div className="modalheaders">  
          <h2>{getData.uploadedFile?.fileName}</h2>
          <ul>
              <li><Tooltip placement="top" title={'Download'}>
              <span className="icon_Downloadstroke"
                onClick={downloadAttachment}></span></Tooltip></li>
            <li>
              <Tooltip placement="top" title={'Close'}
            >
              <span className="icon_close" onClick={closeFileModal}>
              </span></Tooltip></li>
          </ul>
        </div>
        <div className="chatNoteImgContent">
          <iframe title={"webview"}
            src={getData.uploadedFileUrl}
            frameBorder="0"
            scrolling="auto"
            height="400"
            width="100%"
          ></iframe>
        </div>
      </Modal>

      <Modal
        centered
        visible={getData.isPerformanceModal}
        title = "Performance Metrics"
        onCancel={closePerformanceModal}
        className="Performancemodal"> 
        
        <div>
         <div className={styles.ppmetricssectionn}>
          { performanceDataArr && performanceDataArr?.map((elem:any,i:any)=>{
            return (
              <>
              <div className={styles.sectionone} >
              <div className={styles.nameprofile}>
              <div className={styles.topsection}>
                <div className={styles.lefts}>
                  <div  className={`${styles.leftsusercon} ${styles.pinkicon}`}>
                   
                    <div className={styles.useralph}>
                    <URAvatarGroup className={`lefts size32 colorBG${random_color[i]}`}
                          // profileInfo={<><span>{elem.participant.toUpperCase().charAt(0)}</span><URStatusDot className='stsDotsm green' /></>} />
                          profileInfo={<><span>{elem?.participant?.split(' ').map((item:any)=>item?.charAt(0)?.toUpperCase()).join('')}</span><URStatusDot className='stsDotsm green' /></>} />

                    </div>
                  
                  </div>
                  <div className={styles.names}>
                    <h4>{elem.participant}</h4>
                  </div>
                </div>
              </div>
              </div>
  
            <div className={styles.ppmatricssec}>
              <div className={styles.ppmatricscol}>
                <div className={styles.ppmatricscoltxt}>
                  <p>Interaction Ratio</p>
                  <p>Filler Words</p>
                  <p>Speech Rate</p>
                  
                </div>
                <div className={styles.ppmatricscolpctg}>
                  <p>{elem.INTERACTION_RATIO}</p>
                  <p> {elem.FILLER_WORD}</p>
                  <p> {elem.SPEECH_RATE}</p>
                </div>
              </div>
              <div className={styles.ppmatricscol}>
                <div className={styles.ppmatricscoltxt}>
                  <p>Monologue</p>
                  <p>Idle Time</p>
                </div>
                <div className={styles.ppmatricscolpctg}>
                  <p> {elem.MONOLOGUE_LENGTH}</p>
                  <p>{elem.IDLE_TIME}</p>
                </div>
              </div>
            </div>
            
            </div>
            </>
            )
          })}
  
        </div>
      
         
        
        </div>
      


      </Modal>



      <Modal visible={getData.isAlternateHostModal} title="Add Alternate Host"
        centered
        maskClosable={false}
        onOk={addAlternateHost}
        onCancel={closeModal}
        cancelText="Cancel"
        okText="Add"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: `urButton buttonBlue ${(getData.altHostButton || getData.alternateHostVal.length === 0 )? "disabled" : ""}` }} className="customPopup ">
        <div className={styles.hostconSec}>
          <div className={styles.scheduleTitle}>
            <SingleParticipantList alternativeHost={alternateHostDetail} alternateHostModalOpenClose={getData.alternateHostModalOpenClose}></SingleParticipantList>
          </div>
        </div>

      </Modal>
        <Modal title="Remove Alternate Host?"
        centered
        visible={getData.removeAltHostModal}
        onOk={removeAlternateHost}
        onCancel={closeFileModal}
        cancelText="No"
        okText="Yes"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
           Are you sure want to remove the alternate host?
      </Modal>
      <Modal visible={getData.isPreviewImageModal} className="closeFileModalancel imagepreviewmodal">
        <div className="modalheaders">
          <h2>{getData.uploadedFile.fileName}</h2>
          <ul>
            {/* <li>
              <Tooltip placement="top" title={'Delete'}>
                <span className="icon_delete"></span></Tooltip></li>  */}
                <li><Tooltip placement="top" title={'Download'}>
              <span className="icon_Downloadstroke"
                onClick={downloadAttachment}></span></Tooltip></li>
            <li><Tooltip placement="top" title={'Close'}
            >
              <span className="icon_close" onClick={closeFileModal}>
              </span></Tooltip></li>
          </ul>
        </div>
        <div className="imagepreview">
          <ImageZoom url={getData.uploadedFile.fileUrl}></ImageZoom>
        </div>
      </Modal>
      <Modal visible={getData.hoverVisible} title="Participant"
        centered

        onOk={addParticipanttoMeeting}
        onCancel={closeModal1}
        cancelText="Cancel"
        okText="Update"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        maskClosable={false}
        okButtonProps={{ className: getData.participantSipiIdList.length !== 0 ? 'urButton buttonBlue' : ' urButton buttonBlue disabled' }}
        className="customPopup "
      >
        <div className={styles.hostconSec}>
          <div className={styles.scheduleTitle}>

            {/*  <URInput placeHolder="Enter meeting title" name="" className="inputcustomBox"
              value={getData.inputText} onChange={enterTitle} /> */}
            <div className={styles.participantdropcus}>
              <div className={styles.insideicon}>
                {getData.participantSipiIdList.length === 0 && <img src={taskimg2} alt="" />}
                <Select
                  /*  labelInValue = {true} */
                  mode='multiple'
                  style={{ width: '100%' }}
                  placeholder="Select contacts or add email by comma seperation"
                  className={getData.participantSipiIdList.length === 0 ? "newselects taskcreations customdropbox " : "newselects taskcreations customdropbox inputselectlftnone "}
                  dropdownClassName="newChatSel meetingdropdown"
                  /*  optionLabelProp="label" */
                  value={getData.participantSipiIdList}
                  showSearch={true}
                  filterOption={false}
                  onFocus={contactFocus}
                  onChange={popupOnchange}
                  onSearch={searchContact}
                >

                  {/* {allcontact} */}
                  {/* { (favList?.length > 0 &&getData.searchKey==='') && 
          <div className="titlesdrop">Favourite / Frequently Contacted</div>}
                  {favList?.map((contactName: any, index: any) => {

            return <div key={index}>
              <div className="dropdowndesign">
                <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                  profileInfo={
                    (contactName.ImageURL !== null && contactName.ImageURL !== "") ?
                      (<>
                        <img src={contactName.ImageURL} alt="" />
                        <URStatusDot className={ userStatusColor(contactName.user_status,'small')}/></>) :
                      (<>
                        <span>{contactName?.caller_id?.charAt(0).toUpperCase()} </span>
                        <URStatusDot className={ userStatusColor(contactName.user_status,'small')} />
                      </>)
                  } />
                <div className="names">{contactName.caller_id}</div>
                <div className="ext">{contactName.ext }</div>
              </div>
            </div>;
                  })} */}
                  {/* {getData.contactList?.length > 0 &&  <div className="titlesdrop">Contact</div>} */}

                  {(favList?.length > 0 && getData.searchKey === '') &&
                    <div className="titlesdrop">Favourite / Frequently Contacted</div>}
                  {favList?.map((favcontactName: any, index: any) => {

                    return <div key={index} value={favcontactName.sip_login_id}>

                      <div className="dropdowndesign">
                        <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                          profileInfo={
                            (favcontactName.ImageURL !== null && favcontactName.ImageURL !== "") ?
                              (<>
                                <img src={favcontactName.ImageURL} alt="" />
                                <URStatusDot className={userStatusColor(favcontactName.user_status, 'small')} /></>) :
                              (<>
                                <span>{favcontactName?.caller_id?.charAt(0).toUpperCase()} </span>
                                <URStatusDot className={userStatusColor(favcontactName.user_status, 'small')} />
                              </>)
                          } />
                        <div className="names">{favcontactName.caller_id}</div>
                        <div className="ext">{favcontactName.ext}</div>
                      </div>
                    </div>;
                  })}
                  {getData.contactList?.map((contactName: any, index: any) => {
                    let highlighted: any = searchHighlight(contactName, getData.searchKey);
                    return <Option key={JSON.stringify(contactName)} value={contactName.sip_login_id}>
                      {
                        ((getData.contactList[index - 1]?.caller_id)?.charAt(0).toUpperCase()) !==
                        ((contactName?.caller_id)?.charAt(0).toUpperCase()) &&
                        <div className="titlesdrop">{(contactName?.caller_id)?.charAt(0).toUpperCase()} </div>
                      }
                      <div className="dropdowndesign">
                        <div className="usergroupss">
                          <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                            profileInfo={
                              (contactName.ImageURL !== null && contactName.ImageURL !== "") ?
                                (<>
                                  <img src={contactName.ImageURL} alt="" className={styles.imgSelected} />
                                  <URStatusDot className={userStatusColor(contactName.user_status, 'small')} /></>) :
                                (<>
                                  <span>{contactName?.caller_id?.charAt(0).toUpperCase()} </span>
                                  <URStatusDot className={userStatusColor(contactName.user_status, 'small')} />
                                </>)
                            } />
                        </div>
                        {getData.searchKey !== '' ?
                          <div className="names">{(highlighted?.middleMsg !== "") ? (<>{highlighted?.firstMsg}
                            <b className={styles.highlight}>{highlighted?.middleMsg}</b>
                            {highlighted?.lastMsg}</>) :
                            (<>{contactName?.caller_id}</>)}</div> :
                          <div className="names">{contactName.caller_id}</div>}
                        <div className="ext">{contactName.ext}</div>
                      </div>
                    </Option>;
                  })}
                </Select>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

